import { eyebrowDate } from '@obv/core';
import { useDisplay } from '../context';
import { CustomizableHome } from './CustomizableHome';
import { HomeWidget } from './Today';
import { UpdatedPill } from './weatherState';

/**
 * "Family dashboard" scene, modelled on the owner's reference: chore pills and the time across the
 * top, then 2 large and 4 small widgets (salat, weather, plans, chores, habits, calendar by
 * default). Customizable like the home screen, with its own widget list; the template is fixed.
 */
/**
 * "Our family": the dashboard on warm paper — serif type, the household's name, people-first chore
 * pills and a background picked in its customizer. Its own widget list, like the dashboard's.
 */
export function FamilyView() {
  const ctx = useDisplay();
  return (
    <CustomizableHome
      target="family"
      eyebrow={eyebrowDate(ctx.clock.dateKey)}
      pill={<UpdatedPill />}
      renderWidget={(id, narrow) => <HomeWidget id={id} narrow={narrow} />}
    />
  );
}

export function DashboardView() {
  const ctx = useDisplay();
  return (
    <CustomizableHome
      target="dashboard"
      eyebrow={eyebrowDate(ctx.clock.dateKey)}
      pill={<UpdatedPill />}
      renderWidget={(id, narrow) => <HomeWidget id={id} narrow={narrow} />}
    />
  );
}
